import { ApiResponse, PaginatedResponse } from '@/domain';
import { backendApi, paramsSerializerOpt } from '../backendApi';
import { PaymentPlanData, SubscriptionFilters } from '@/domain/agreements/agreement';

export interface CreatePaymentPlanRequest {
  contractId: string;
  initialAmount?: number;
  installmentAmount: number;
  installments: number;
}

export const paymentPlansApi = {
  getPaymentPlans: (filters?: SubscriptionFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<PaymentPlanData>>>('/api/v1/data/payment-plans', paramsSerializerOpt(filters)).then((res) => res.data.data),

  createPaymentPlan: (data: CreatePaymentPlanRequest) =>
    backendApi.post<ApiResponse<any>>(`/api/v1/payment-plans`, data).then((res) => res.data.data),

  deletePaymentPlan: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/payment-plans/${id}`).then((res) => res.data.data),

  modifyPaymentPlan: (planId: string, data: { installments: number; installmentAmount: number }) =>
    backendApi.put<ApiResponse<any>>(`/api/v1/payment-plans/${planId}`, data).then((res) => res.data.data)
};
